import Exam from "@/views/exams/exam.vue";
import Exams from "@/views/exams/index.vue";

export default [
  {
    path: "exames",
    name: "Exames",
    component: Exams,
  },
  {
    path: "exames/:examId",
    name: "Editar exame",
    props: true,
    component: Exam,
  },
  {
    path: "exames/:examId/solicitacao/:medicalRequestId",
    name: "Editar exame com solicitacao",
    props: true,
    component: Exam,
  },
];
